import React from "react"
import { useTranslation } from "react-i18next"
import AppMap from "../map/AppMap"

const SchoolStationSection = props => {
  const school = props.school
  const studyCenters = school.dataContext
    ? school.dataContext.scholarships
    : props.school.studyCenters

  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const studyCentresShouldBeCropped = studyCenters.length > 10
  const croppedStudyCentres = studyCentresShouldBeCropped
    ? studyCenters?.slice(0, 10)?.sort((a, b) => a.name?.localeCompare(b.name))
    : [].slice.call(studyCenters).sort((a, b) => a.name?.localeCompare(b.name))
  const remainingStudyCentres = studyCentresShouldBeCropped ? studyCenters.slice(10, studyCenters.length) : ""
  const remainingStudyCentresNames = remainingStudyCentres ? remainingStudyCentres.map(studyCenter => {
    return studyCenter.name
  }).join(" ") : ""

  const resolveStationDistance = currSchool => {
    if (currSchool.transportStationResolved) {
      return (
        <div className="location-airport">
          {t("school.location.airport")}
          <div>
            {currSchool.transportStationResolved} (
            {currSchool.distanceToStation} {t("school.location.km")},{" "}
            {currSchool.timeToStation} {t("school.location.min")})
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  let mapDeterminator = props.contactsPage ? "" : "col-lg-7"
  let stationsDeterminator = props.contactsPage ? "w-100 mt-5" : "col"

  return (
    <div className="row mt-5 justify-content-center station-location-wrapper">
      <div
        className={`direct-school-location ${mapDeterminator} d-flex justify-content-center`}
      >
        <AppMap width={660} height={560} items={[school]} isSchoolPage={true}></AppMap>
      </div>
      {props.contactsPage ? (
        <div
          style={{
            paddingRight: "calc(var(--bs-gutter-x) * .5)",
            paddingLeft: "calc(var(--bs-gutter-x) * .5)",
          }}
        >
          <div className={`location-desc-tag ${stationsDeterminator} p-5`}>
            {school.isSummer ? (
              <div className="d-flex flex-column h-100 justify-content-between">
                <div className="location-title">
                  {t("school.header.study-centers")}
                </div>
                <div className="d-flex flex-column flex-wrap">
                  {croppedStudyCentres
                    ?.slice(0, croppedStudyCentres.length - 1)
                    .map(studyCenter => {
                      return (
                        <div className="location-area">
                          &#8226;&nbsp;{studyCenter.name}&#160;
                        </div>
                      )
                    })}
                  {croppedStudyCentres != null && (
                    <div className="location-area">
                      &#8226;&nbsp;{croppedStudyCentres[croppedStudyCentres?.length - 1]?.name}
                    </div>
                  )}
                  {studyCentresShouldBeCropped &&
                    <div title={remainingStudyCentresNames} className="location-area curs-P">
                      {currentLang === "en" ?
                        t("search.andMore1") + " " + remainingStudyCentres.length + " " + t("search.andMore2") :
                        t("search.andMore1") + " " + t("search.andMore2") + " " + remainingStudyCentres.length}
                    </div>
                  }
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column h-100 justify-content-between">
                <div className="location-title">
                  {t("school.location.location")}
                </div>
                <div className="location-tag-info mt-8">
                  <div className="location-title">{school.settlement}</div>
                  <div className="location-area">{school.regionResolved}</div>
                  {resolveStationDistance(school)}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={`location-desc-tag ${stationsDeterminator} p-5`}>
          {school.isSummer ? (
            <div className="d-flex flex-column h-100 justify-content-between">
              <div className="location-title">
                {t("school.header.study-centers")}
              </div>
              <div className="d-flex flex-column flex-wrap">
                {croppedStudyCentres
                  ?.slice(0, croppedStudyCentres.length - 1)
                  .map(studyCenter => {
                    return (
                      <div className="location-area">
                        &#8226;&nbsp;{studyCenter.name}&#160;
                      </div>
                    )
                  })}
                {croppedStudyCentres != null && (
                  <div className="location-area">
                    &#8226;&nbsp;{croppedStudyCentres[croppedStudyCentres?.length - 1]?.name}
                  </div>
                )}
                {studyCentresShouldBeCropped &&
                  <div title={remainingStudyCentresNames} className="location-area curs-P">
                    {currentLang === "en" ?
                      t("search.andMore1") + " " + remainingStudyCentres.length + " " + t("search.andMore2") :
                      t("search.andMore1") + " " + t("search.andMore2") + " " + remainingStudyCentres.length}
                  </div>
                }
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column h-100 justify-content-between">
              <div className="location-title">
                {t("school.location.location")}
              </div>
              <div className="location-tag-info mt-8">
                <div className="location-title">{school.settlement}</div>
                <div className="location-area">{school.regionResolved}</div>
                {resolveStationDistance(school)}
              </div>
            </div>
          )}
        </div>
      )}

    </div>
  )
}
export default SchoolStationSection
